<template>
  <div id="app">
    <v-app>
      <v-content class="pt-1">
         <v-container fluid fill-height class="back-image">
           <v-img height="120px" contain src="../assets/vFeedLogoLg.png" class="float-image"/>
           <v-layout align-center justify-center class="pt-2">
            <v-flex xs12 sm8 md6 lg4>
              <v-card class="elevation-12">
                <v-toolbar color="primary" flat>
                   <v-icon class="me-3">mdi-login-variant</v-icon>
                  <v-toolbar-title>{{$t('Login')}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pb-0 mb-4">
                  <v-form>
                    <v-text-field :label="$t('e-mail')"
                        v-model="username"
                        prepend-icon="mdi-account"
                        type="text"
                        autocomplete="username" >
                    </v-text-field>
                    <v-text-field :label="$t('Password')"
                        v-model="password"
                        prepend-icon="mdi-lock"
                        type="password"
                        autocomplete="password" >
                     </v-text-field>
                     <v-checkbox v-if="false"
                        v-model="saveLogin"
                        :label="$t('Save credentials on this computer')"
                        color="primary">
                     </v-checkbox>
                  </v-form>
                </v-card-text>
                <v-card-actions class="pt-0">
                   <v-btn class="ma-2 mt-4 py-2 px-4" outlined color="primary" href="https://www.getvfeed.com/signup" target="_blank">
                     <v-icon left>mdi-account-plus</v-icon> {{$t('Signup')}}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn class="ma-2 mt-4 py-2 px-4" color="primary" @click="login" @keyup.enter="login">
                     <v-icon left>mdi-login-variant</v-icon> {{$t('Login')}}
                  </v-btn>
                </v-card-actions>
              </v-card>

            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
   name: "login",
   props: {
      show_register: {
         type: Boolean,
         required: false,
         default: false
      }
   },
   data() {
      return {
        username: "",
        password: "",
        saveLogin: false,
      }
   },

   created() {
   },
   methods: {
      login() {
         try {
            let _locale = this.$i18n.locale;
            let _darkTheme = this.$vuetify.theme.dark;
            this.$store.dispatch("loginUser", {email: this.username.trim(), password: this.password.trim(), root: this.$root});
            const _profile = this.$store.getters.getProfile;
            this.$vuetify.theme.dark = !(_profile.lightTheme);
            //check if locale or theme has changed..
            if (_locale != this.$i18n.locale || _darkTheme != this.$vuetify.theme.dark) {
               //save cookie with chosen locale
               const cookieExpire = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
               document.cookie = "locale=" + _locale + "; expires=" + cookieExpire.toString();
               document.cookie = "theme=" + (_darkTheme ? "dark" : "light") + "; expires=" + cookieExpire.toString();
               window.location.reload();
            }
          } catch (error) {
            //this.$root.$globalSnackbar(this.$i18n.t('Fail to login')+ ": " + error.message);
         }
      },
      signup() {
         //This link moved to  https://www.getvfeed.com/signup
         //this.$router.push("signup")
         return;
      }
   },
   computed: {
      currentUser() {
         return this.$store.getters.getUser;
      }
   },
   watch: {
      currentUser() {
        this.$router.replace({name: "dashboard"});
      }
   }




};
</script>

<style>
   .float-image{
      position: fixed;
      top: 10%;
      left: 50%;
      transform: translateX(-50%);
   }
</style>